import { GET_ROUTE_CONFIG } from '../types'

const INITIAL_STATE = {
  sendRootList: [],
}

const routeListReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ROUTE_CONFIG:
      return {
        ...state,
        sendRootList: payload.data,
      }

    default:
      return state
  }
}

export default routeListReducer
